// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"d225fe21","376":"df876047"}[chunkId] + ".chunk.css";
};